
const TOGGLE_LOADING = 'global/TOGGLE_LOADING';
const GET_MAINHEIGHT = 'global/GET_MAINHEIGHT';


export default {
  state: {
    loading: false,
    mainHeight: '',
  },
  actions: {
    
  },
  /* eslint-disable no-param-reassign */
  mutations: {
    [TOGGLE_LOADING](state, status) {
      switch (status) {
        case 'start':
          state.loading = true;
          break;
        case 'finish':
          state.loading = false;
          break;
        case 'error':
          state.loading = false;
          break;
        default:
      }
    },
    [GET_MAINHEIGHT](state, height) {
      state.mainHeight = height;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/global.js